import React, { FC } from 'react';
import StaticBlogPage from 'src/components/base-components/StaticPage/StaticBlogPage';
import StaticPromotionPage from 'src/components/base-components/StaticPage/StaticPromotionPage';
import '../styles.scss';

const staticPages = {
  promotions: <StaticPromotionPage />,
  blog: <StaticBlogPage />,
};
type Props = {
  page: string;
};
const StaticPageConstructor: FC<Props> = ({ page }) => {
  return staticPages[page];
};
export default StaticPageConstructor;
